import React, { useContext } from 'react'
import Svg from 'svg'

import ActionButton from 'uiComponents/buttons'
import { Col, Row } from 'uiComponents/flex'
import ConviousLogo from 'images/logo-mini.svg'
import PricePreview from './pricePreview'
import { useHistory, useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import ResetToDefault from './resetToDefault'
import RtpProductsWarning from './rtpProductsWarning'
import StudioContext from './provider/context'
import { DoNotEditSettingsWarningMessage } from './doNotEditWarning'
import './layout.scss'
import { Trans, useTranslation } from 'translations'

const GPSStudioLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const { accountSlug } = useParams<BaseRouteParams>()
    const { articles, isLoading } = useContext(StudioContext)

    const goBack = () => {
        history.push(`/account/${accountSlug}/dashboard/overview/`)
    }

    return (
        <Row wrap="nowrap" className="gpsStudioLayout">
            <Col
                span="auto"
                style={{ minWidth: '5rem', flexBasis: '5rem', backgroundColor: '#E7EAEC', padding: '1.5rem 0' }}
            >
                <Row align="center">
                    <Svg style={{ height: 40, width: 40 }} src={ConviousLogo} />
                </Row>
            </Col>
            <Col span="auto" style={{ flexGrow: 1, background: 'white' }}>
                <Row
                    style={{
                        padding: '1rem 1rem 1.5rem 0',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        background: 'white',
                    }}
                >
                    <Col span={12}>
                        <Row align="flex-end">
                            <Col span="auto">
                                <ActionButton onClick={goBack} secondary style={{ marginRight: '1rem' }} size="large">
                                    {t('globalPricingSettings.studio.layout.exit')}
                                </ActionButton>
                                <ActionButton type="submit" size="large">
                                    {t('common.save')}
                                </ActionButton>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ padding: '0 1rem 0.5rem 1.5rem' }}>
                    <Col span={12}>
                        <div className="header">
                            <h1>{t('globalPricingSettings.studio.layout.title')}</h1>
                            <div className="subtitle" role="doc-subtitle">
                                <Trans
                                    i18nKey="globalPricingSettings.studio.layout.subtitle"
                                    components={{
                                        anchor: (
                                            <a
                                                target="_blank"
                                                href="https://support.convious.com/help/how-to-use-advance-settings-to-fine-tune-pricing-factors"
                                                rel="noreferrer"
                                            />
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={12} style={{ minHeight: '1rem' }}>
                        <div className="messagesContainer">
                            <DoNotEditSettingsWarningMessage />
                            {!isLoading && articles.length === 0 && <RtpProductsWarning accountSlug={accountSlug} />}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span="auto" id="settings">
                        {children}
                    </Col>
                    <Col span="auto" id="sidePanel">
                        <aside>
                            <PricePreview />
                            <ResetToDefault />
                        </aside>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default GPSStudioLayout
